import { Grid, Select, Option } from '@pega/cosmos-react-core';
import React from 'react';
import useLocalTranslation from '../../hooks/useLocalTranslation';

interface DisplayVonageTwilioProps {
  createAccountVia: string;
  setAccountType: (e: any) => void;
  accountType: string;
}

const DisplayVonageTwilioOptions: React.FC<DisplayVonageTwilioProps> = (props) => {
  const translate = useLocalTranslation();

  const updateType = async (e: any) => {
    props.setAccountType(e);
  };

  return (
    <Grid
      container={{
        cols: 'repeat(2, 1fr)',
        gap: 2,
      }}
    >
      <Select
        label={translate(props.accountType)}
        value={props.createAccountVia}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
          updateType(e.target.value);
        }}
      >
        <Option value="twilio">{translate('twilio')}</Option>
        <Option value="vonage">{translate('vonage')}</Option>
      </Select>
    </Grid>
  );
};

export default DisplayVonageTwilioOptions;
